import { SVGProps, Ref, forwardRef } from 'react';

export const UserFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.097 6.837C.777 5.397.812 3.5 1.2 1c3.057.806 5.925.55 8.94.282C11.705 1.142 13.309 1 14.998 1 20 1 22.8 4 22.8 9c-4.447-3.334-8.213-2.5-11.694-1.728-2.784.616-5.386 1.193-8.009-.435m-.949 1.53a8 8 0 0 1-.59-.404C1.172 9.252 1 10.626 1 12c0 5.5 2.75 11 11 11s11-5.5 11-11q0-.305-.011-.609l-1.269-.95c-1.753-1.315-3.315-1.846-4.746-2.006-1.467-.165-2.898.045-4.444.369q-.485.103-1.004.222c-2.72.618-6.088 1.382-9.378-.66m8.508 8.217c-.18-.191-.256-.393-.256-.584H8.6c0 .71.296 1.339.744 1.816.644.686 1.617 1.084 2.656 1.084s2.012-.398 2.656-1.084c.449-.477.744-1.106.744-1.816h-1.8c0 .19-.076.393-.256.584-.268.286-.747.516-1.344.516s-1.076-.23-1.344-.516"
                fill="currentColor"
            />
        </g>
    </svg>
));
UserFilledSize24Glyph.displayName = 'UserFilledSize24Glyph';
